"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Recentre = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 24 24" },
        react_1.default.createElement(react_native_svg_1.G, { fill: color, "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { d: "M0 0H24V24H0z", transform: "translate(-327 -188) translate(319 180) translate(8 8)" }),
            react_1.default.createElement(react_native_svg_1.Path, { fill: "#212121", d: "M12 2c.245 0 .45.177.492.41l.008.09v2.518c3.468.245 6.238 3.015 6.482 6.483L21.5 11.5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492l-.09.008h-2.518c-.244 3.468-3.014 6.238-6.482 6.482V21.5c0 .276-.224.5-.5.5-.245 0-.45-.177-.492-.41l-.008-.09v-2.518c-3.467-.244-6.237-3.014-6.482-6.482H2.5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492l.09-.008h2.518c.244-3.467 3.015-6.238 6.483-6.482L11.5 2.5c0-.276.224-.5.5-.5zm0 4c-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm0 3c1.487 0 2.72 1.081 2.959 2.5H15v1h-.042C14.72 13.92 13.486 15 12 15c-1.486 0-2.72-1.08-2.958-2.5H9v-1h.041C9.28 10.081 10.513 9 12 9zm0 1c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z", transform: "translate(-327 -188) translate(319 180) translate(8 8)" }))));
};
Recentre.defaultProps = {
    color: '#FFFFFF',
    width: 24,
    height: 24,
};
exports.default = react_1.default.memo(Recentre);
